import { FC } from 'react';
import { PATH } from '@app/index';
import { PrimaryTab } from '@shared/tabs';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useJackpotHighlightedTabs } from '@features/Jackpot/JackpotTabs/hooks/useJackpotHighlightedTabs';
import { JackpotTabEnum } from '@entities/jackpot';

const gameConnectorTabsItems = [
  { labelKey: 'lotto', path: PATH.LOTTERY_ALL_AT_ONCE },
  { labelKey: 'jackpot', path: PATH.JACKPOT },
  { labelKey: 'referral', path: PATH.REFERRAL },
];

export const GameConnectorTabs: FC = () => {
  const location = useLocation();

  const { t } = useTranslation('mainPage');
  const highlightTabs = useJackpotHighlightedTabs();

  return (
    <>
      {gameConnectorTabsItems.map((item, index) => {
        const isActive = location.pathname === item.path;

        const hasReward =
          item.path === PATH.JACKPOT &&
          (highlightTabs[JackpotTabEnum.TopPlayers] ||
            highlightTabs[JackpotTabEnum.PartnersJackpot] ||
            highlightTabs[JackpotTabEnum.PlatinumJackpot] ||
            highlightTabs[JackpotTabEnum.MyJackpots]);

        return (
          <PrimaryTab
            key={index}
            label={t(item.labelKey)}
            link={item.path}
            isActive={isActive}
            hasReward={hasReward}
            dataTutorial={item.path === PATH.JACKPOT ? 'jackpot-tab' : undefined}
          />
        );
      })}
    </>
  );
};
